import Icon from "./Icon";

export const EditButtonIcon = (props) => {
    const iconName = !props.editMode ? 'edit' : 'check';
    
    return (
        <Icon name={iconName} {...props}/>
    );
}

export default EditButtonIcon;